//import config from 'config';
import { handleResponse, requestOptions } from '@/_helpers';


export const userService = {
    register,
    getAll,
    getAllBuildings,
    getById,
    changepassword,
    deleteUser
};

function register(username, password, firstName, lastName) {
    return fetch('/api/users/register', requestOptions.post({ username, password, firstName, lastName }))
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
          //  currentUserSubject.next(user);

            return user;
        });
}

function changepassword(token, password) {
    return fetch('/api/users/changepassword', requestOptions.post({ token, password }))
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            //localStorage.setItem('currentUser', JSON.stringify(user));
            //  currentUserSubject.next(user);

            return user;
        });
}

function getAll() {
    return fetch('/api/users', requestOptions.get())
        .then(handleResponse);
}

function getAllBuildings(userId) {
    return fetch('/api/buildings/user?id='+userId, requestOptions.get())
        .then(handleResponse);
}

function getById(id) {
    return fetch('/api/users/'+id, requestOptions.get())
        .then(handleResponse);
}

function deleteUser(id) {
    return fetch('/api/users/' + id, requestOptions.delete({
        id
    }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}